import React, { useEffect, useState } from 'react';
import { LOGIN_LINK } from '../constants/constants';
const LogoutPage = () => {
    const [redirectTo,setRedirectTo] = useState(false);
    useEffect(()=>{
        localStorage.removeItem('userinfo');
        localStorage.removeItem('token');
        
        setTimeout(()=>{
            setRedirectTo(true);
        },2000);
        
    },[]);

    if(redirectTo){ window.location.href = LOGIN_LINK}
    return(<>
    </>);
}
export default LogoutPage;